import { call, put, takeLatest } from "redux-saga/effects";
import { getAllClassWithSectionDetailsRequest, getAllClassWithSectionDetailsSuccess } from "./classWithSectionDetailsListSlice";
import { GetAllClassWithDetailsMapping } from "../../api/ClassPeriods/ClassWithStrSubsSecService";

function* fetchClassWithSectionDetailsSaga(action) {
  try {
    const { schoolID } = action.payload;
    const response = yield call(GetAllClassWithDetailsMapping, schoolID);
    yield put(getAllClassWithSectionDetailsSuccess(response?.data)); 
  } catch (error) {
    yield put(getAllClassWithSectionDetailsSuccess([])); 
    // yield put(getClassPeriodsFailure(error.message || "Something went wrong"));
  }
}

export default function* watchClassWithDetailsMapping() {
  yield takeLatest(getAllClassWithSectionDetailsRequest.type, fetchClassWithSectionDetailsSaga);
}

